const cardListElem = document.querySelector('.card-list');

if (cardListElem) {
  // **************************************************
  // Filter via axios
  // **************************************************

  const cardListInner = cardListElem.querySelector('.card-list__list-inner');
  const cardListShowMore = cardListElem.querySelector('.card-list__footer--show-more');
  const noResultFound = cardListElem.querySelector('.card-list__no-result');
  const searchField = cardListElem.querySelector('#filter-search');
  let cardListPageNumber = parseInt(cardListElem.getAttribute('data-page'));

  const axiosGetFilteredCardList = async (categories, pageNumber, loadMore, inputValue) => {
    try {
      const { data } = await axios.post(localData.siteURL, {
        id: localData.id,
        pageK: cardListElem.getAttribute('page-k'),
        action: 'getFilteredCardListPosts',
        postType: cardListElem.getAttribute('data-list-type'),
        listChoice: cardListElem.getAttribute('data-list-choice'),
        pageNumber,
        searchValue: inputValue,
        filteredCategories: JSON.stringify(categories),
      });

      const { pageLink, postType, posts } = data.data;

      window.history.replaceState(null, null, pageLink);
      const filteredPosts = posts;

      const cardListRow = cardListElem.querySelectorAll('.card-list__row');

      if (postType === 'accommodation') {
        // hide all rows
        cardListRow.forEach((elem) => {
          elem.classList.add('hide');
          const cardListRowInner = elem.querySelector('.card-list__list-inner');
          cardListRowInner.innerHTML = '';
        });

        // compare all rows with response rowId and show it with ajax html
        filteredPosts.forEach((item) => {
          const filteredRowId = item.rowId;
          const matchedRow = cardListElem.querySelector(`[row-category-id="${filteredRowId}"]`);
          const normalRowId = parseInt(matchedRow.getAttribute('row-category-id'));

          matchedRow.classList.remove('hide');
          const matchedRowTitle = matchedRow.querySelector('.card-list__row-title');
          matchedRowTitle.classList.remove('hide');

          const matchedRowInner = matchedRow.querySelector('.card-list__list-inner');
          const matchedRowHTML = `<div class="col-md-4 : col-sm-6 : col-xs-12 : card-list__item">${item.html}</div>`;

          if (normalRowId === filteredRowId) {
            matchedRow.classList.remove('hide');
            matchedRowInner.innerHTML += matchedRowHTML;
          }
        });

        noResultFound.classList.toggle('hide', filteredPosts.length > 0);
      } else {
        if (!loadMore) {
          cardListInner.innerHTML = '';
        }

        const cardListInnerHTML = filteredPosts
          .map((item) => `<div class="col-md-4 : col-sm-6 : col-xs-12 : card-list__item">${item}</div>`)
          .join('');

        if (!loadMore) {
          cardListInner.innerHTML = cardListInnerHTML;
        } else {
          cardListInner.innerHTML += cardListInnerHTML;
        }

        noResultFound.classList.toggle('hide', cardListInnerHTML !== '');
        cardListShowMore.classList.toggle('hide', filteredPosts.length < 12);
      }
    } catch (error) {
      console.error(error);
    }
  };

  // **************************************************
  // Dropdown
  // **************************************************

  const dropdownElem = cardListElem.querySelectorAll('.dropdown');
  const selectedCategories = {}; // Object to store selected categories

  // get checked items array
  const getActiveCategoryIds = (checkedItems) =>
    Array.from(checkedItems)
      .map((checkedItem) => checkedItem.getAttribute('id'))
      .join('|');

  const checkedItems = (dropdown, dropdownType) => {
    const checkedItems = dropdown.querySelectorAll('input[type="checkbox"]:checked');
    const itemValues = getActiveCategoryIds(checkedItems);
    selectedCategories[dropdownType] = itemValues;
  };

  const checkActiveDropdown = () => {
    dropdownElem.forEach((dropdown) => {
      const dropdownType = dropdown.querySelector('input').getAttribute('data-fv-name');
      const dropdownInputs = dropdown.querySelectorAll('input');

      dropdownInputs.forEach(() => {
        checkedItems(dropdown, dropdownType);
      });
    });
  };

  // Dropdown checkbox change event for filter posts
  dropdownElem.forEach((dropdown) => {
    const dropdownType = dropdown.querySelector('input').getAttribute('data-fv-name');
    const dropdownInputs = dropdown.querySelectorAll('input');

    dropdownInputs.forEach((input) => {
      selectedCategories[dropdownType] = '';
      input.addEventListener('change', () => {
        dropdown.classList.remove('is-open');
        cardListElem.setAttribute('data-page', (cardListPageNumber = 1));
        checkedItems(dropdown, dropdownType);
        axiosGetFilteredCardList(selectedCategories, cardListPageNumber, false, searchField.value);
      });
    });
  });

  // **************************************************
  // Load more
  // **************************************************

  const loadMoreAction = () => {
    attachEvent('.card-list__footer--show-more .btn', 'click', () => {
      cardListElem.setAttribute('data-page', ++cardListPageNumber);
      checkActiveDropdown();
      axiosGetFilteredCardList(selectedCategories, cardListPageNumber, true, searchField.value);
    });
  };

  if (cardListShowMore) {
    loadMoreAction();
  }

  // **************************************************
  // Search
  // **************************************************

  if (searchField) {
    searchField.addEventListener(
      'keyup',
      debounce((e) => {
        const inputValue = e.target.value;

        if (e.keyCode === 32 || e.key === 'Enter' || e.keyCode === 13) {
          e.preventDefault();
          return;
        }

        cardListElem.setAttribute('data-page', (cardListPageNumber = 1));
        checkActiveDropdown();
        axiosGetFilteredCardList(selectedCategories, cardListPageNumber, false, inputValue);
      }, 300),
    );
  }

  // Reload page - Accommodation Page
  window.addEventListener('load', () => {
    if (cardListElem.classList.contains('card-list--hotel-list')) {
      const cards = cardListElem.querySelectorAll('.mod-card');
      const allRows = cardListElem.querySelectorAll('.card-list__row');
      allRows.forEach((row) => {
        const rowCards = row.querySelectorAll('.mod-card');
        if (rowCards.length === 0) {
          row.classList.add('hide');
        }
      });
      noResultFound?.classList.toggle('hide', cards.length > 0);
    }
  });
}
